import * as $ from 'jquery';

export class YoutubeService {

    static init() {
        $(window).resize(YoutubeService.updateLayout);
        $(document).on('click', 'a[href="#preview"]', () => setTimeout(YoutubeService.updateLayout, 500));
        //$(document).ready(() => YoutubeService.updateLayout());
    }

    public static updateLayout() {
        /*
        var players = $('.row:visible .youtube-video');
        players.each((i, p) => {
            let player = $(p);

            //calc 16:9 rate minusz 2px(padding)
            let screenX = player.parent().width() - 4;
            let screenY = ((screenX / 16) * 9 );

            //set palyer
            player.width(screenX);
            player.height(screenY);
        });
         */
    }

}